/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Media_Loaded_MessageInputs */



/**
* | output |
* | --- |
* | "Media loaded successfully" |
*
* @param {Iframe_Remote_Media_Loaded_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_media_loaded_message = /** @type {((inputs?: Iframe_Remote_Media_Loaded_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Media_Loaded_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Media charge avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien erfolgreich geladen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Supporto caricato correttamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Медиафайл успешно загружен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios cargados exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体文件加载成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアが正常に読み込まれました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया सफलतापूर्वक लोड हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia carregada com sucesso")
	return /** @type {LocalizedString} */ ("Media loaded successfully")
});